import { render, staticRenderFns } from "./produit_add_edit.vue?vue&type=template&id=9cbe124c&scoped=true&"
import script from "./produit_add_edit.vue?vue&type=script&lang=js&"
export * from "./produit_add_edit.vue?vue&type=script&lang=js&"
import style0 from "./produit_add_edit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./produit_add_edit.vue?vue&type=style&index=1&id=9cbe124c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbe124c",
  null
  
)

export default component.exports